import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayPictureComponent } from './display-picture.component';



@NgModule({
    declarations: [DisplayPictureComponent],
    imports: [
        CommonModule
    ],
    exports: [DisplayPictureComponent]
})
export class DisplayPictureModule { }
